import useStore from "../../store/store";
import styles from '../../style.module.scss';
import {useEffect, useState} from "react";
import formatHours from "../../utils/format-hours";
import formatDate from "../../utils/format-date";
import {host} from "../../const/const";

const CheckAvailable = () => {
    const carId = useStore((state) => state.carId)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const availableMode = useStore((state) => state.availableMode)
    const [available, setAvailable] = useState(true);
    const [message, setMessage] = useState('');
    const [icon, setIcon] = useState(null);

    const getApiData = async (carId, start, finish) => {
        try {
            const response = await fetch(
                `${host}?action=check_available_car&id=${carId}&start=${start}&finish=${finish}`
            ).then((response) => response.json());
            if (response?.message) {
                setAvailable(false);
                setMessage(response.message)
                if (response?.icon){
                    setIcon(response.icon)
                }
            } else {
                setAvailable(true);
                setMessage('');
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    useEffect(() => {
        if (startDate && startHours !== null && finishDate && finishHours !== null && carId && availableMode === 1) {
            const start = `${formatDate(startDate)} ${formatHours(startHours)}`;
            const finish = `${formatDate(finishDate)} ${formatHours(finishHours)}`;
            getApiData(carId, start, finish);
        }
    }, [startDate, startHours, finishDate, finishHours, carId, availableMode]);

    if (available) {
        return null;
    }
    return (
        <div className={`${styles.availableMessage} p-small-size`}>
            {!!icon && (<img src={icon} width={20} height={20} alt=''/>)}
            {message}
        </div>
    );
};

export default CheckAvailable;